import InputWrapper from "../../../../../../../components/input/wrapper/InputWrapper";
import { useLanguageContext } from "../../../../../../../context/LanguageContext";
import EVAApiHelper from "../../../../../../../helpers/EVAApiHelper";
import { StyledInput } from "../../../../../../../styles/InputStyles";
import {
  StyledFlexColumn,
  StyledFlexItem,
  StyledFlexRow,
} from "../../../../../../../styles/LayoutStyles";

function SizeFormView({
  selectedLabelItem,
  selectedLabelItemIndex,
  onWidthChange,
  onHeightChange,
  submitError,
}) {
  const { translate } = useLanguageContext();

  return (
    <StyledFlexColumn>
      <StyledFlexRow>
        <StyledFlexItem>
          <InputWrapper
            label={translate(
              "eva.main.validation.attributes.label_items.*.width"
            )}
            required
            error={EVAApiHelper.getResponseError(
              `label_items.${selectedLabelItemIndex}.width`,
              submitError
            )}
          >
            <StyledInput
              type="number"
              value={selectedLabelItem.width}
              onChange={onWidthChange}
            />
          </InputWrapper>
        </StyledFlexItem>

        <StyledFlexItem>
          <InputWrapper
            label={translate(
              "eva.main.validation.attributes.label_items.*.height"
            )}
            required
            error={EVAApiHelper.getResponseError(
              `label_items.${selectedLabelItemIndex}.height`,
              submitError
            )}
          >
            <StyledInput
              type="number"
              value={selectedLabelItem.height}
              onChange={onHeightChange}
            />
          </InputWrapper>
        </StyledFlexItem>
      </StyledFlexRow>
    </StyledFlexColumn>
  );
}

export default SizeFormView;
